import { Typography } from '@repo/ui';
import styles from './ActionPlan.module.css';

type PageType = 'action-plan' | 'results';

interface PendingResultsBannerProps {
  latestKitDate: string;
  currentKitDate: string;
  pageType?: PageType;
}

const PendingResultsBanner = ({
  latestKitDate,
  currentKitDate,
  pageType = 'action-plan',
}: PendingResultsBannerProps) => {
  const message =
    pageType === 'results'
      ? `Your results from the ${latestKitDate} kit are on the way! While we finish them up, here are your most recent results from your previous kit (${currentKitDate}).`
      : `Your action plan from the ${latestKitDate} kit is on the way! While we finish it up, here's your most recent action plan from your previous results (${currentKitDate}).`;

  return (
    <div className={styles.pendingResultsBanner}>
      <Typography variant='body-s' className={styles.pendingResultsBannerText}>
        {message}
      </Typography>
    </div>
  );
};

export default PendingResultsBanner;
